// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"728":"46285381","928":"054dc7b5"}[chunkId] + ".chunk.css";
};